import React from 'react';
import {useStateConfig} from '@/hooks/useStateConfig';
import {router} from '@/router';
import {Button} from '@common/Logo.styles';

export default function Logo() {
  const stateConfig = useStateConfig();

  return (
    <Button onClick={() => router.navigate('/clients')}>
      <img
        src={`${process.env.REACT_APP_CARECO_API_BASE_URL}${stateConfig?.branding.logo}`}
        alt={`${stateConfig?.branding.name} Powered by Bamboo Health`}
        fetchPriority="high"
      />
    </Button>
  );
}
